import React from 'react';
import { useInViewportVideo } from '@/lib/motion';
import { fileUrl } from '@/lib/api';

/** Section background renderer supporting color | image | video, with overlay. */
export default function SectionBackground({ section = {}, fallbackColor = 'transparent', children }) {
  const type = section.background_type || 'color';
  const overlay = typeof section.overlay_opacity === 'number' ? section.overlay_opacity : 0;
  const image = fileUrl(section.background_image || section.background_value || '');
  const video = fileUrl(section.background_video || '');
  const useVideo = !!section.use_video && !!video;
  const videoRef = useInViewportVideo();
  const bgColor = type === 'color' ? (section.background_value || fallbackColor) : (type === 'image' || useVideo ? '#0A0A0C' : fallbackColor);

  return (
    <div className="relative isolate" style={{ backgroundColor: bgColor }}>
      {/* Image layer */}
      {type !== 'color' && image && !useVideo && (
        <div
          className="absolute inset-0 -z-10 bg-center bg-cover will-change-transform"
          style={{ backgroundImage: `url(${image})` }}
          aria-hidden
        />
      )}
      {/* Video layer */}
      {useVideo && (
        <video
          ref={videoRef}
          className="absolute inset-0 -z-10 w-full h-full object-cover"
          src={video}
          muted
          loop
          playsInline
          autoPlay
          preload="metadata"
          aria-hidden
        />
      )}
      {/* Dark overlay */}
      {overlay > 0 && (
        <div
          className="absolute inset-0 -z-10 pointer-events-none"
          style={{ backgroundColor: `rgba(10,10,12,${overlay})` }}
          aria-hidden
        />
      )}
      {children}
    </div>
  );
}
